const REQUIRED_FIELDS = [
  { key: 'firstName', label: 'First Name' },
  { key: 'lastName', label: 'Last Name' },
  { key: 'mobileNumber', label: 'Mobile Number' },
  { key: 'email', label: 'Email' },
  { key: 'ctc', label: 'CTC in LPA' },
  { key: 'ectc', label: 'ECTC in LPA' },
  { key: 'totalYoe', label: 'Total YOE' },
  { key: 'relevantYoe', label: 'Relevant YOE' },
  { key: 'lwd', label: 'LWD' },
  { key: 'currentLocation', label: 'Current Location' },
  { key: 'prefLocation', label: 'Preferred Location' },
  { key: 'currentOrg', label: 'Current Org' },
  { key: 'candidateSkills', label: 'Source Profile Skills' },
  { key: 'role', label: 'Role' },
  { key: 'feedback', label: 'Recruiter Feedback' },
  { key: 'educationalQualification', label: 'Educational Qualification' },
  { key: 'offerInHand', label: 'Offer in Hand' },
];

export function validateCandidateUploadForm(values = {}) {
  for (const field of REQUIRED_FIELDS) {
    if (!String(values[field.key] || '').trim()) {
      return { ok: false, message: `${field.label} is required.` };
    }
  }

  if (!['Yes', 'No'].includes(String(values.resignationServed || '').trim())) {
    return { ok: false, message: 'Resignation Served is required (Yes or No).' };
  }

  return { ok: true };
}
